module.exports = __webpack_public_path__ + "img/maps.e0370125.png";